import { Client, Account, Databases, Storage, Functions } from 'appwrite';
import { AppwriteConfig } from '../types';



// Appwrite-Konfiguration
export const appwriteConfig: AppwriteConfig = {
  endpoint: process.env.REACT_APP_APPWRITE_ENDPOINT || 'https://cloud.appwrite.io/v1',
  projectId: process.env.REACT_APP_APPWRITE_PROJECT_ID || '',
  databaseId: process.env.REACT_APP_APPWRITE_DATABASE_ID || '',
  storageBuckets: {
    articleImages: process.env.REACT_APP_APPWRITE_STORAGE_BUCKET_ARTICLE_IMAGES || 'article-images',
  },
  collections: {
    users: process.env.REACT_APP_APPWRITE_COLLECTION_USERS || 'users',
    platforms: process.env.REACT_APP_APPWRITE_COLLECTION_PLATFORMS || 'platforms',
    articles: process.env.REACT_APP_APPWRITE_COLLECTION_ARTICLES || 'articles',
    editorDrafts: process.env.REACT_APP_APPWRITE_COLLECTION_EDITOR_DRAFTS || 'editor_drafts',
    categories: process.env.REACT_APP_APPWRITE_COLLECTION_CATEGORIES || 'categories',
    dossiers: process.env.REACT_APP_APPWRITE_COLLECTION_DOSSIERS || 'dossiers',
    schedules: process.env.REACT_APP_APPWRITE_COLLECTION_SCHEDULES || 'schedules',
    auditLogs: process.env.REACT_APP_APPWRITE_COLLECTION_AUDIT_LOGS || 'audit_logs',
    publishMappings: process.env.REACT_APP_APPWRITE_COLLECTION_PUBLISH_MAPPINGS || 'publish_mappings',
    books: process.env.REACT_APP_APPWRITE_COLLECTION_BOOKS || 'books',
    socialMediaBackgrounds: process.env.REACT_APP_APPWRITE_COLLECTION_SOCIAL_MEDIA_BACKGROUNDS || 'social_media_backgrounds',
    kiAuthorsConfigs: process.env.REACT_APP_APPWRITE_COLLECTION_KI_AUTHORS_CONFIGS || 'ki_authors_configs',
    kiAuthorsRuns: process.env.REACT_APP_APPWRITE_COLLECTION_KI_AUTHORS_RUNS || 'ki_authors_runs',
    dachthekenduettConfigs: process.env.REACT_APP_APPWRITE_COLLECTION_DACHTHEKENDUETT_CONFIGS || 'dachthekenduett_configs',
    articleExtractorConfigs: process.env.REACT_APP_APPWRITE_COLLECTION_ARTICLE_EXTRACTOR_CONFIGS || 'article_extractor_configs',
  },
};

// Appwrite-Client initialisieren
export const client = new Client()
  .setEndpoint(appwriteConfig.endpoint)
  .setProject(appwriteConfig.projectId);

// API-Key wird für Frontend-Anwendungen nicht benötigt
// Die Authentifizierung erfolgt über Sessions

// Appwrite-Services
export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const functions = new Functions(client);

// Datenbank-ID
export const databaseId = appwriteConfig.databaseId;
